export enum AnalyticsUserRole {
  // Admin roles
  ROLE_IREMBOGOV_ADMIN = 'IREMBOGOV_ADMIN',
  ROLE_SUPER_ADMIN = 'SUPER_ADMIN',
  ROLE_AGENCY_ADMIN = 'AGENCY_ADMIN',
  ROLE_ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  ROLE_OFFICER_ADMIN = 'OFFICER_ADMIN',

  // Manager roles
  ROLE_SERVICE_DISTRIBUTION_MANAGER = 'SERVICE_DISTRIBUTION_MANAGER',
  ROLE_PARTNERSHIP_MANAGER = 'PARTNERSHIP_MANAGER',
  ROLE_INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  ROLE_OFFICER_MANAGER = 'OFFICER_MANAGER',
  ROLE_SERVICE_MANAGER = 'SERVICE_MANAGER',
  ROLE_CONTENT_MANAGER = 'CONTENT_MANAGER',
  ROLE_REPORTS_MANAGER = 'REPORTS_MANAGER',
  ROLE_SERVICE_CENTER_MANAGER = 'SERVICE_CENTER_MANAGER',
  ROLE_CLINIC_MANAGER = 'CLINIC_MANAGER',

  // Officer/Agent roles
  ROLE_OFFICER = 'OFFICER',
  ROLE_AGENT = 'AGENT',
  ROLE_INTEGRATION_OPS = 'INTEGRATION_OPS',
  ROLE_SERVICE_CENTER_AGENT = 'SERVICE_CENTER_AGENT',

  // Organization roles
  ROLE_ORGANIZATION_EXECUTIVE = 'ORGANIZATION_EXECUTIVE',
  ROLE_ORGANIZATION_SUPPORT = 'ORGANIZATION_SUPPORT',

  // Other roles
  ROLE_CITIZEN = 'CITIZEN',
  ROLE_QA_REVIEWER = 'QA_REVIEWER',
  ROLE_SUPER_SERVICE_PROVIDER = 'SUPER_SERVICE_PROVIDER',
  ROLE_CLINICIAN = 'CLINICIAN',
}
